module.exports = __webpack_public_path__ + "d3d9624a7423a9cd7fbe23b50ca7af3b.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/content/assets/2080_teaser_image.jpg
// module id = 588
// module chunks = 0